module.exports = __webpack_public_path__ + "img/invest_advertising-sp.2427f777.jpg";